// extracted by mini-css-extract-plugin
export default {"table":"Table_table__lFhnG","table__head":"Table_table__head__VMGlJ","table__body":"Table_table__body__XK2LA","table__row":"Table_table__row__g+FE6"};